export default [
    {
        path: '/poliza/index',
        name: 'PolizaView',
        component: () => import('../views/constructor/PolizaView.vue')
    },
    {
        path: '/producto/index',
        name: 'ProductoView',
        component: () => import('../views/constructor/ProductoView.vue')
    },
    {
        path: '/plan-cobertura/index',
        name: 'PlanesCoberturasSeguroView',
        component: () => import('../views/constructor/PlanesCoberturasSeguroView.vue')
    },
    {
        path: '/tasas/index',
        name: 'TasasView',
        component: () => import('../views/constructor/TasasView.vue')
    },
    {
        path: '/condicion-particular/index',
        name: 'CondicionParticularView',
        component: () => import('../views/constructor/CondicionParticularView.vue')
    },
    {
        path: '/asignacion-condicion/index',
        name: 'AsignacionCondicionGeneralYClausulaView',
        component: () => import('../views/constructor/AsignacionCondicionGeneralYClausulaView.vue')
    },
    {
        path: '/parametro-cis/index',
        name: 'ParametroCISView',
        component: () => import('../views/constructor/ParametroCISView.vue')
    },
    {
        path: '/poliza-tradicional/index',
        name: 'PolizaTradicionalView',
        component: () => import('../views/constructor/PolizaTradicionalView.vue')
    },
]